import AnimeInfo from './AnimeInfo';
import animeInfoSlice, { fetchAnimeInfo } from './animeInfoSlice';

export default AnimeInfo;
export { animeInfoSlice, fetchAnimeInfo };
